module.exports = __webpack_public_path__ + "img/logowarna.3c0ae284.svg";